<template>
  <div class="monitor-container">
    <!-- 1. 顶部操作区 (固定高度) -->
    <div class="header-section">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>监控管理</el-breadcrumb-item>
      </el-breadcrumb>

      <!-- 搜索筛选表单 -->
      <el-form :inline="true" class="search-form">
        <el-form-item>
          <el-select
            size="small"
            v-model="storeId"
            placeholder="请选择门店"
            @change="changeCamera"
          >
            <el-option
              v-for="type in storeList"
              :label="type.key"
              :value="type.value"
              :key="type.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="single"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @change="maskClick"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="warning" icon="el-icon-document" @click="clickRecord">
            门店记录
          </el-button>
        </el-form-item>
        <el-form-item v-if="IsHuiFan">
          <el-button size="small" type="success" icon="el-icon-video-camera" @click="BackZhiBo">
            回到直播
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 2. 视频监控区 (自动铺满剩余空间，Grid网格自适应) -->
    <div class="video-section">
      <div class="video-grid" :style="gridStyle">
        <!-- 💡 新增：加入 @dblclick 双击事件 -->
        <div
          class="video-wrapper"
          v-for="item in CameraDevice"
          :key="item.id"
          @dblclick="DoubleClick(item)"
        >
          <!-- 播放器容器 -->
          <div class="video-container" :id="'video-container' + item.id"></div>
          <!-- 叠加的摄像头名称标识 -->
          <div class="video-title">{{ extractCameraName(item.deviceName) }}</div>
        </div>
      </div>
    </div>

    <!-- 弹窗：门店记录 -->
    <el-dialog title="门店操作记录" :visible.sync="dialogVisible" width="65%" top="5vh">
      <el-table :data="CameraDeviceLogList" style="width: 100%" height="500" border stripe>
        <el-table-column prop="openTime" label="时间" width="180"></el-table-column>
        <el-table-column prop="camerlog" label="动作记录" min-width="250"></el-table-column>
        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              v-if="row.operate == 8"
              @click="clickDetail(row)"
              type="success"
              plain
              size="mini"
            >详情</el-button>
            <el-button type="primary" plain size="mini" @click="seeHuiFan(row)">回放</el-button>
            
            <el-popover
              placement="left"
              trigger="click"
              :title="phoneText"
              @show="clickTrace(row)"
              @hide="hideTrace"
              v-if="row.wxUserId"
            >
              <el-table :data="JinMneList" height="300" size="mini">
                <el-table-column property="openTime" label="时间" width="160"></el-table-column>
                <el-table-column property="desctions" label="描述" width="150"></el-table-column>
                <el-table-column label="操作" width="80">
                  <template slot-scope="scope">
                    <el-button type="primary" plain size="mini" @click="seeHuiFan1(scope.row)">回放</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button slot="reference" type="danger" plain size="mini" style="margin-left: 10px;">跟踪</el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 弹窗：订单详情 -->
    <el-dialog title="订单详情" :visible.sync="dialogFormDetail" width="500px">
      <el-form :model="OrderDesc" label-width="90px" size="small">
        <el-form-item label="订单号">
          <el-input v-model="OrderDesc.orderNum" disabled></el-input>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-input v-model="OrderDesc.orderStatus" disabled :style="OrderDesc.OrderColor"></el-input>
        </el-form-item>
        <el-form-item label="订单内容">
          <el-input v-model="OrderDesc.content" type="textarea" :rows="3" disabled></el-input>
        </el-form-item>
        <el-form-item label="订单金额">
          <el-input v-model="OrderDesc.price" disabled>
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-input v-model="OrderDesc.createTime" disabled></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormDetail = false" size="small">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  CameraDevice,
  CameraDeviceListreq,
  CameraUserDevice,
  orderById
} from "../../api/api";
// import EZUIKit from "../../components/ezuikit-js/ezuikit-js/ezuikit.js";
import EZUIKit from 'ezuikit-js';


export default {
  data() {
    return {
      storeId: Number(localStorage.getItem("storeId")) || null,
      storeList: [], 
      single: "", 
      LogTime: "", 
      
      CameraDevice: [],
      accessToken: "",
      IsHuiFan: false, 

      dialogVisible: false,
      dialogFormDetail: false,
      
      CameraDeviceLogList: [],
      JinMneList: [],
      OrderDesc: {},
      phoneText: "",

      statusMap: {
        "0": { label: "生成中", color: "color: orange" },
        "1": { label: "已完成", color: "color: #25A785" },
        "2": { label: "已取消", color: "color: gray" },
        "3": { label: "已退款", color: "color: red" }
      }
    };
  },

  computed: {
    gridStyle() {
      const len = this.CameraDevice.length;
      if (len === 1) return { gridTemplateColumns: '1fr' };
      if (len === 2) return { gridTemplateColumns: 'repeat(2, 1fr)' };
      if (len > 2 && len <= 4) return { gridTemplateColumns: 'repeat(2, 1fr)' };
      if (len > 4 && len <= 9) return { gridTemplateColumns: 'repeat(3, 1fr)' };
      return { gridTemplateColumns: 'repeat(4, 1fr)' };
    }
  },

  created() {
    this.players = [];
    this.initDate();
    this.getStoreLists();
  },

  mounted() {
    if (this.storeId) {
      this.CameraDeviceReq();
    }
  },

  beforeDestroy() {
    this.destroyPlayers();
  },

  methods: {
    // 💡 完全参考 Dashboard.vue 的全屏处理逻辑
    // 💡 彻底抛弃 SDK 的全屏 API，使用纯原生 HTML5 强制全屏
    DoubleClick(item) {
      const name = "video-container" + item.id;
      const wrapper = document.getElementById(name).parentNode;
      
      // 检查当前是否已经全屏
      const isFullScreen = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;

      if (isFullScreen) {
        this.exitFullScreen();
      } else {
        // 直接让最外层的 .video-wrapper 强行全屏，绝不调用 player.fullScreen()
        const reqFS = wrapper.requestFullscreen || wrapper.webkitRequestFullscreen || wrapper.mozRequestFullScreen || wrapper.msRequestFullscreen;
        if (reqFS) reqFS.call(wrapper);
      }
      
      // 触发窗口重绘，强制让内部视频等比例放大铺满
      setTimeout(() => { window.dispatchEvent(new Event('resize')); }, 300);
    },

    // 💡 完全参考 Dashboard.vue 的退出全屏处理逻辑
    exitFullScreen() {
      var el = document;
      var cfs = el.cancelFullScreen || el.mozCancelFullScreen || el.msExitFullscreen || el.webkitExitFullscreen || el.exitFullscreen;
      if (cfs) {
        cfs.call(el);
      } else if (typeof window.ActiveXObject !== 'undefined') {
        // 兼容 IE
        var wscript = new ActiveXObject('WScript.Shell');
        if (wscript != null) {
          wscript.SendKeys('{F11}');
        }
      } else {
        console.warn('浏览器不支持全屏API或已被禁用');
      }
    },
    initDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const date = String(now.getDate()).padStart(2, "0");
      this.single = `${year}-${month}-${date}`;
    },

    getStoreLists() {
      try {
        const stored = localStorage.getItem("storeLitst");
        if (stored) {
          const parsed = JSON.parse(stored);
          this.storeList = parsed.map(item => ({ ...item, value: item.id }));
        }
      } catch (error) {
        console.error("解析 storeLitst 失败:", error);
        this.storeList = [];
      }
    },

    changeCamera() {
      this.initDate();
      this.IsHuiFan = false;
      this.CameraDeviceReq();
    },

    CameraDeviceReq() {
      if (!this.storeId) return;
      
      CameraDevice(this.storeId).then((res) => {
        if (res.code == 0) {
          this.accessToken = res.data.accessToken;
          this.CameraDevice = res.data.cameraDevices || [];
          
          this.$nextTick(() => {
            this.initAllPlayers();
          });
        } else {
          this.$message.error(res.message || res.msg || '获取设备列表失败');
        }
      });
    },

    async initAllPlayers() {
      this.destroyPlayers(); 
      await this.$nextTick();

      for (let i = 0; i < this.CameraDevice.length; i++) {
        let item = this.CameraDevice[i];
        item.currentUrl = item.currentUrl || item.hdAddress; 
        this.initPlayer(item);
        await new Promise(resolve => setTimeout(resolve, 800));
      }
    },

    // 初始化单个播放器 (恢复到最干净的状态，不再去黑客拦截它)
    initPlayer(data) {
      try {
        const containerId = "video-container" + data.id;
        const container = document.getElementById(containerId);
        
        if (!container) return;

        const realWidth = container.clientWidth || 400;
        const realHeight = container.clientHeight || 300;

        let player = new EZUIKit.EZUIKitPlayer({
          id: containerId, 
          accessToken: this.accessToken,
          url: data.currentUrl,
          template: "security", 
          // width: realWidth,   
          // height: realHeight, 

          width: '100%',     // 恢复为 100%
          height: '100%',    // 恢复为 100%
          
          // ❌ 核心：删除了 useHardDev: true，避开硬解模式的全屏 Bug
          useHardDev: true,
          // 加上官方标准的日志控制器配置，屏蔽无用信息
          loggerOptions: {
              name: "ezuikit",
              level: "ERROR",
              showTime: false
          }
        });
        
        this.players.push(player);
      } catch (error) {
        console.error(`初始化摄像头${data.id}失败`, error);
      }
    },
    destroyPlayers() {
      if (this.players && this.players.length > 0) {
        this.players.forEach(p => {
          if (p && typeof p.stop === 'function') p.stop();
        });
        this.players = []; 
        
        this.CameraDevice.forEach(item => {
          const el = document.getElementById("video-container" + item.id);
          if(el) el.innerHTML = '';
        });
      }
    },

    BackZhiBo() {
      this.IsHuiFan = false;
      this.initDate();
      this.initAllPlayers();
    },

    maskClick(dateStr) {
      if (!dateStr) return;
      this.single = dateStr;
      
      const today = new Date().toISOString().split('T')[0];
      this.IsHuiFan = (dateStr !== today);
      this.LogTime = this.single;
      
      this.CameraDeviceList();
      this.BakcCamera();
    },

    extractCameraName(fullName) {
      if (!fullName) return "未命名摄像头";
      const match = fullName.match(/\d.*/);
      return match ? match[0] : "未命名摄像头";
    },

    timeToTimestamp(dateStr) {
      const d = new Date(dateStr);
      const pad = (n) => (n < 10 ? "0" + n : n);
      return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
    },

    BakcCamera() {
      const startDate = new Date(this.LogTime);
      const begin = this.timeToTimestamp(startDate);
      
      const endDate = new Date(startDate);
      endDate.setDate(endDate.getDate() + 1);
      const end = this.timeToTimestamp(endDate);

      this.CameraDevice.forEach((item) => {
        let url = item.localPlaybackAddress || '';
        if (url.includes("begin=")) {
          url = url.replace(/begin=\d+&end=\d+/, `begin=${begin}&end=${end}`);
        } else {
          url += `${url.includes('?') ? '&' : '?'}begin=${begin}&end=${end}`;
        }
        item.currentUrl = url;
      });

      this.initAllPlayers();
    },

    clickRecord() {
      this.CameraDeviceList();
      this.dialogVisible = true;
    },

    CameraDeviceList() {
      CameraDeviceListreq({ storeId: this.storeId, time: this.single }).then((res) => {
        if (res.code == 0) { 
          this.CameraDeviceLogList = res.data
            .filter(item => item.operate !== 9) 
            .map(item => {
              item.camerlog = this.formatCameraLog(item);
              return item;
            });
        } else {
          this.$message.error(res.message || res.msg || '获取记录失败');
        }
      });
    },

    formatCameraLog(item) {
      const { operate, phone, wxUserId, adminId, businessId, desctions } = item;
      const userIdent = phone ? `尾号[${phone.slice(-4)}]` : `客户id[${wxUserId}]`;
      const manager = adminId ? `客服[${adminId}]` : (businessId ? `商户[${businessId}]` : '未知管理员');

      switch (operate) {
        case 0: return (adminId || businessId) ? `${manager}远程开门` : `${userIdent}的[${desctions}]`;
        case 1: return `${manager}解锁门店`;
        case 2: return `${manager}常闭门店`;
        case 3: return `用户【${businessId || ''}${adminId || ''}】上线云值守`;
        case 4: return `用户【${businessId || ''}${adminId || ''}】下线云值守`;
        case 5: return `客服打开对讲[${desctions}]`;
        case 6: return `客服结束对讲[${desctions}]`;
        case 7: return desctions;
        case 8: return `客户买单[${desctions}]`;
        default: return '未知操作';
      }
    },

    clickDetail(row) {
      if(!row.adminId) return;
      orderById(row.adminId).then((res) => {
        if (res.code == 0) { 
          this.OrderDesc = res.data;
          const status = this.statusMap[res.data.orderStatus] || { label: '未知', color: '' };
          this.OrderDesc.orderStatus = status.label;
          this.OrderDesc.OrderColor = status.color;
          this.dialogFormDetail = true;
        }
      });
    },

    seeHuiFan(item) {
      this.dialogVisible = false;
      this.IsHuiFan = true;
      this.LogTime = item.openTime;
      this.BakcCamera();
    },

    clickTrace(item) {
      this.phoneText = `[${item.phone || item.wxUserId}]的相关记录`;
      CameraUserDevice(item.wxUserId).then((res) => {
        if (res.code == 0) { 
          this.JinMneList = res.data || [];
        }
      });
    },
    
    hideTrace() {
      this.phoneText = "";
      this.JinMneList = [];
    },

    seeHuiFan1(item) {
      this.IsHuiFan = true;
      this.LogTime = item.openTime;
      this.single = item.openTime.split(" ")[0]; 
      this.CameraDeviceList();
      this.BakcCamera();
      
      this.dialogVisible = false;
      document.body.click(); 
    }
  }
};
</script>

<style scoped>
/* 整个页面满屏容器 */
.monitor-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 100px); /* 视你的外层框架头部高度而定，如果是独立页面可写 100vh */
  background-color: #f0f2f5;
  padding: 15px;
  box-sizing: border-box;
}

/* 顶部操作区 */
.header-section {
  background: #fff;
  padding: 15px 20px 0 20px;
  border-radius: 8px;
  margin-bottom: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  flex-shrink: 0;
}

.breadcrumb {
  margin-bottom: 15px;
}

.search-form {
  display: flex;
  flex-wrap: wrap;
}

/* 视频监控区 - 自适应剩余高度 */
.video-section {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  overflow: hidden; /* 防止溢出 */
  display: flex;
  flex-direction: column;
}

/* Grid 网格自适应布局核心代码 */
.video-grid {
  flex: 1;
  display: grid;
  gap: 15px;
  /* 列数由计算属性 gridStyle 动态控制 */
  /* 设置最小行高，自动填充 */
  grid-auto-rows: 1fr; 
  width: 100%;
  height: 100%;
}

.video-wrapper {
  position: relative;
  background-color: #000;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-container {
  width: 100%;
  height: 100%;
}

/* 覆盖层：摄像头名称 */
.video-title {
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  pointer-events: none; /* 防止遮挡视频点击操作 */
  z-index: 10;
}

/* 调整弹窗内表格样式 */
::v-deep .el-dialog__body {
  padding: 10px 20px 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/charts/jiankong.vue